import script from "./CommerceB2bPricingProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./CommerceB2bPricingProduct.vue?vue&type=script&setup=true&lang=js"

import "./CommerceB2bPricingProduct.vue?vue&type=style&index=0&id=7df337d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df337d6"]])

export default __exports__